<template>
    <router-view name="unauthorized"/>
</template>
<script>
export default {
    head: {
        title: {
            inner: '1Autorent'
        },
        meta: [
            { name: 'application-name', content: '1Autorent' },
            { name: 'description', content: 'Autorent' },
            { itemprop: 'name', content: 'Autorent' },
            { itemprop: 'description', content: 'Autorent' },
            { property: 'og:title', content: 'Autorent' },
        ],
    },
};
</script>
